import { render } from "./ManageSemestersView.vue?vue&type=template&id=12f80798&scoped=true"
import script from "./ManageSemestersView.vue?vue&type=script&lang=js"
export * from "./ManageSemestersView.vue?vue&type=script&lang=js"

import "./ManageSemestersView.vue?vue&type=style&index=0&id=12f80798&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f80798"]])

export default __exports__